module.exports = __webpack_public_path__ + "55af093efeb2a51d5b46aa4a557488ce.svg";